export const toolbarOptions = {
  container: [[{ header: [2, false] }], ["bold", "italic", "underline"]],
  handlers: {},
};

export const toolbarOptions2 = {
  container: [[{ header: [2, false] }], ["bold", "italic", "underline"]],
  handlers: {},
};

export const toolbarOptions3 = {
  container: [],
  handlers: {},
};

export const toastOptions = {
  position: "bottom-right",
  autoClose: 4000,
  pauseOnHover: true,
  draggable: true,
  theme: "dark",
};

export const convertTo12Hour = (time24) => {
  const [hour, minute] = time24.split(":").map(Number);
  const ampm = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minute.toString().padStart(2, "0")} ${ampm}`;
};
